import * as React from "react";

import { cn } from "@/lib/utils";

type InputProps = React.ComponentProps<"input">;
function Input({ className, type, ...props }: InputProps) {
	const finalClassName = cn(
		"flex h-9 w-full border border-input min-w-0 bg-transparent px-3 py-1 text-base transition-[color,box-shadow] outline-none placeholder:text-muted-foreground md:text-sm",
		// "file:text-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
		"focus-visible:border-input-focus focus-visible:inset-ring-1 focus-visible:inset-ring-input-focus", // On focus, change border color and add inset ring
		// "selection:bg-primary selection:text-primary-foreground",
		// "aria-invalid:inset-ring-destructive/20 aria-invalid:border-destructive",
		"disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
		"read-only:cursor-default read-only:opacity-95 read-only:bg-foreground/5",
		className,
	);

	return (
		<input
			type={type}
			data-slot="input"
			className={finalClassName}
			{...props}
		/>
	);
}

export { Input };
export type { InputProps };
